import { Carrier, CarrierCreateRequest, CarrierSearchRequest, CarrierUpdateRequest, DataResponseCarrier, Policy, PolicyUpdateRequest } from "@bluefalcon/clients-management-client-fetch";
import { falconClients } from "../clients/falcon.client";

export class CarriersService {

    async createCarrier(request: CarrierCreateRequest): Promise<void> {
        return falconClients.carriers.createCarriers({
            carrierCreateManyRequest: { req: [request] },
        });
    }

    async searchCarriers(options?: CarrierSearchRequest): Promise<DataResponseCarrier> {
        return falconClients.carriers.searchCarriers({
            carrierSearchRequest: options,
        });
    }

    async getCarrierById(id: number): Promise<Carrier> {
        return falconClients.carriers.getCarrierById({
            id,
        });
    }

    async updateCarrierById(id: number, request: CarrierUpdateRequest): Promise<Carrier> {
        return falconClients.carriers.updateCarrierById({
            id,
            carrierUpdateRequest: request,
        });
    }

    async getPolicyById(id: number): Promise<Policy> {
        return falconClients.carriers.getPolicyById({
            id,
        });
    }

    async updatePolicyById(id: number, request: PolicyUpdateRequest): Promise<Policy> {
        return falconClients.carriers.updatePolicyById({
            id,
            policyUpdateRequest: request,
        });
    }

    async deletePolicyById(id: number): Promise<void> {
        return falconClients.carriers.deletePolicyById({
            id,
        });
    }
}